// レビューの4,2,3,5,3のような配列は以下の配列に対応した評価軸になります。4(重さ),2(素材感),3(足長),5(足幅),3(フィット感) 
const rankingInfo = [
  {
    title: "重い",
    leftText: "軽い",
    rightText: "重い"
  },
  {
    title: "素材感",
    leftText: "柔らかめ",
    rightText: "硬め"
  },
  {
    title: "足長",
    leftText: "短い",
    rightText: "長い"
  },
  {
    title: "足幅",
    leftText: "狭い",
    rightText: "広い"
  },
  {
    title: "フィット感",
    leftText: "きつめ",
    rightText: "緩め"
  }
];


// - FUNCTIONS
function _sumEvaluations(arr) {
  // 入力の文字列をカンマで分割し、整数の配列に変換する
  const arrays = arr.map(s => s.split(',').map(Number));
  // 要素ごとに足し合わせる
  const result = arrays.reduce((acc, curr) => {
    for (let i = 0; i < curr.length; i++) {
      acc[i] = (acc[i] || 0) + curr[i];
    }
    return acc;
  }, []);

  // 結果をカンマ区切りの文字列に変換る
  const resultStr = result.join(',');
  return resultStr.split(',').map(Number);
};

function _averageEvaluation(arr) {
  const result = [];
  const sumEvaluation = _sumEvaluations(arr);
  for (let i = 0; i < arr.length; i++) {
    const rank = (sumEvaluation[i] / evaluations.length).toFixed(0);
    result.push(rank);
  }
  return result;
}

function createRatingHTML(index, evaluation) {
  return `
    <div class="ae-item-rank-text ae-item-rank-text-left">${rankingInfo[index].leftText}</div>
    <div class="ae-item-rank-wrapper">
      <div class="ae-item-rank">
        <div class="ae-item-rank-line"></div>
        ${[1, 2, 3, 4, 5].map(j => `
          <div class="default-mark ${evaluation == j ? 'active-mark' : ''}"></div>
        `).join('')}
      </div>
    </div>
    <div class="ae-item-rank-text ae-item-rank-text-right">${rankingInfo[index].rightText}</div>
  `;
}

function createEvaluationRanking(arr) {
  const averageEvaluation = _averageEvaluation(arr);
  const customInfoElem = document.getElementById('product-custom-review');

  let html = `
    <div class="ae-container">
      <p class="ae-title">平均評価</p>
    </div>
    <div class="ae-content">
  `;

  for (let i = 0; i < rankingInfo.length; i++) {
    html += `
      <div class="ae-item">
        <div class="ae-item-title">${rankingInfo[i].title}</div>
        ${createRatingHTML(i, averageEvaluation[i])}
      </div>
    `;
  }

  html += `</div>`;

  customInfoElem.innerHTML += html;
}
/*
document.addEventListener('DOMContentLoaded', () => {

  const addToCartButtons = document.querySelectorAll('.sp-add-to-cart-button');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      console.log("addToCartVariantButton clicked");
      event.preventDefault();
      button.disabled = true;
      button.style.fontSize = "10px";
      // button.innerHTML = "カートに追加中...";

      const variantId = button.getAttribute('data-variant-id');
      const currentUrl = new URL(window.location.href);

      // URLに ?variant=variant.id を付与
      currentUrl.searchParams.set('variant', variantId);
      const updatedUrl = currentUrl.toString();

      // Shopifyのカートに追加
      fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      }).then(response => response.json()).then(data => {
        if (!data.status) {
          alert("カートに追加しました");

          
    const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartDrawer = doc.getElementById('cart-drawer');
    document.getElementById('cart-drawer').innerHTML = newCartDrawer.innerHTML;

          
        } else {
          console.log("status: ", data.status, "message: ", data.message);
          alert("カートに追加できませんでした。" + data.message ? data.message : "");
        }
      })
        .catch(error => {
          console.error('エラーが発生しました:', error);
        }).finally(() => {
          button.disabled = false;
          addToCartButtonText.innerHTML = "カートに入れる";
        });
      // 必要に応じてURLを更新
      window.history.pushState({}, '', updatedUrl);
    });
  });

  // 追加: フォームの送信を無効化
  const productForm = document.getElementById('product-form-main-7761381228777-template--18354792595689__main');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      // 必要に応じてここにフォーム送信時の追加処理を記述
      console.log('フォームの送信が無効化されました。');
    });
  }




});

*/